import { GzDashboardUnsavedChangesDialogContentWebComponent } from './component/GzDashboardUnsavedChangesDialogContentWebComponent';

export { GzDashboardUnsavedChangesDialogContentWebComponent };
